export default {
  GA_CATEGORY: 'Election_Newsletter',
  NUDGE_SUBSCRIBE_COOKIE: 'electionnlsubscription',
  HEADING: `Don't miss`,
  SUBHEADING: `anything!`,
  TEXT: 'Latest Election updates right in your inbox',
  RESPONSE_HEADING: 'Thank you for subscribing!',
  // SUB_RESPONSE_HEADING: 'subscribing!',
  RESPONSE_TEXT:
    'Your subscription is confirmed for the latest election updates.',
  EMAIL_INVALID: 'Invalid id. Please enter again',
  ADD_SUBSCRIPTION_URL:
    'https://timesofindia.indiatimes.com/newsletter/addsubscription/',
  EXPIRY_DAYS: 7,
  EXPIRY_KEY: 'is_Subscribed',
  ALREADY_SUBSCRIBED: 'This email is already subscribed.',
};
